import BasePolicy from '@/policies/BasePolicy.js';

export default class GroupPolicy extends BasePolicy {
    viewAny(user) {
        const permission = 'view all groups';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    viewAnyOnUserPage(user, person) {
        return (
            user.id === person.id ||
            user.hasPermissionTo('view groups on profile page') ||
            user.hasGroupPermissionTo('view groups on profile page')
        );
    }

    view(user, group) {
        const permission = 'view a group';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(group);
        }

        return user.hasPermissionTo(permission);
    }

    create(user) {
        const permission = 'create a group';

        if (user.hasGroupPermissionTo(permission)) {
            return false;
        }

        return user.hasPermissionTo(permission);
    }

    update(user, group) {
        const permission = 'edit a group';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(group);
        }

        return user.hasPermissionTo(permission);
    }

    delete(user) {
        const permission = 'delete a group';

        return user.hasPermissionTo(permission);
    }
}
